import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExternalAccoutingConfirmationComponent } from './external-accouting-confirmation.component';
import { MatDialogModule } from '@angular/material/dialog';
import { BlankDialogModule } from '@shared/components/blank-dialog/blank-dialog.module';



@NgModule({
  declarations: [
    ExternalAccoutingConfirmationComponent
  ],
  imports: [
    CommonModule,
    MatDialogModule,
    BlankDialogModule
  ]
})
export class ExternalAccoutingConfirmationModule { }
